var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWind = function SvgWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.3 12.2H3.8c-.6 0-1-.4-1-1s.4-1 1-1h13.5c1.5 0 2.7-1.2 2.7-2.7s-1.2-2.7-2.7-2.7-2.7 1.2-2.7 2.7c0 .6-.4 1-1 1s-1-.4-1-1c0-2.6 2.1-4.7 4.7-4.7S22 4.9 22 7.5s-2.1 4.7-4.7 4.7m-1.6 9.1c-2.1 0-3.8-1.7-3.8-3.9 0-.6.4-1 1-1s1 .4 1 1c0 1 .8 1.9 1.8 1.9s1.8-.8 1.8-1.9-.8-1.9-1.8-1.9H5.5c-.6 0-1-.4-1-1s.4-1 1-1h10.2c2.1 0 3.8 1.7 3.8 3.9s-1.7 3.9-3.8 3.9M3 8.7h5.3c1.7 0 3.1-1.4 3-3 0-1.6-1.3-3-3-3-.9 0-1.7.4-2.3 1-.3.4-.3 1 .1 1.4.4.3 1 .3 1.4-.1.3-.3.5-.4.8-.3.5 0 1 .4 1 1 0 .5-.4 1-1 1H3c-.6 0-1 .4-1 1s.4 1 1 1",
    clipRule: "evenodd"
  })));
};
export default SvgWind;